import { i18nConstants } from '@tweddle-se-team/common/constants'
import { Nav, Dropdown } from 'rsuite'
import { FaGlobe } from 'react-icons/fa6'
import { LanguageDropdown } from './headerElements'
import useTranslation from '@/hooks/useTranslation'

const { LANGUAGES } = i18nConstants

const getLanguage = (locale = 'en') => LANGUAGES.find(lang => lang.code === locale)?.label

function HeaderLanguage({ locale, changeLocale = () => {} }) {
  const t = useTranslation()
  const currentLanguage = getLanguage(locale)
  return (
    <LanguageDropdown id="languageDropdown" icon={<FaGlobe size={24} />} noCaret>
      <Nav.Item>
        <p>Language:</p>
        <strong>{t(currentLanguage, currentLanguage)}</strong>
      </Nav.Item>
      <Dropdown.Separator />
      {LANGUAGES.map(({ code, label }) => (
        <Nav.Item key={code} active={code === locale} onClick={() => changeLocale(code)}>
          {t(label, label)}
        </Nav.Item>
      ))}
    </LanguageDropdown>
  )
}

export default HeaderLanguage
